import React from "react";
import "./index.css";
const SearchView = (propsInfo) => {
  const { searchText, onChangeText } = propsInfo;
  return (
    <div className="input-group mb-3">
      <span className="input-group-text" id="basic-addon1">
        <i className="bi bi-search"></i>
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchText}
        onChange={(e) => onChangeText(e.target.value)}
      />
    </div>
  );
};

export default SearchView;
